import { DialogBoundary, DialogTrigger } from "@suse-o11y/dialog";
import React from "react";
import { useSelector } from "react-redux";

import { isPlayground } from "../../../../app/state/config/ConfigSelectors";
import type { MonitorCheckStatus } from "../../../../common/openapi";
import { MonitorPreviewDrawer } from "../../../../components/_monitor-preview-drawer";

interface MonitorIntroProps {
	monitorStatus: MonitorCheckStatus;
}

export const MonitorIntro: React.FC<MonitorIntroProps> = ({ monitorStatus }) => {
	const playground = useSelector(isPlayground);

	return (
		<div className="xxl:max-w-3/4 py-4" data-testid="monitor-intro">
			<h2 className="mb-4 text-2xl leading-7">{monitorStatus.message}</h2>
			<p className="m-0 text-grey-800 leading-6" data-testid="monitor-description">
				{monitorStatus.monitorDescription}
				{!playground && (
					<>
						{" "}
						See the{" "}
						<DialogBoundary>
							<DialogTrigger className="link link-primary">monitor definition</DialogTrigger>
							<MonitorPreviewDrawer
								initialTab="yaml"
								monitorId={monitorStatus.monitorId.id}
								title={monitorStatus.monitorName}
							/>
						</DialogBoundary>{" "}
						for details.
					</>
				)}
			</p>
		</div>
	);
};
